import script from "./AppSupportGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSupportGrid.vue?vue&type=script&setup=true&lang=ts"

import "./AppSupportGrid.vue?vue&type=style&index=0&id=0d21baa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d21baa6"]])

export default __exports__